import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const slug = value => String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const DiscoveryField = ({ field, value, error, onChange }) => {
  const id = `discovery-${field.key}`;
  const full = field.type === 'textarea' || field.type === 'multiselect' || field.type === 'radio';
  const label = <>{field.label} {field.required ? <em>*</em> : <small>(optional)</small>}</>;

  const control = () => {
    switch (field.type) {
      case 'textarea':
        return <Textarea id={id} value={value} placeholder={field.placeholder} maxLength={5000} onChange={e => onChange(e.target.value)} className={`form-input form-textarea ${error ? 'input-error' : ''}`} data-testid={id} />;
      case 'select':
        return <Select value={value} onValueChange={onChange}>
          <SelectTrigger id={id} className="form-input" data-testid={id}><SelectValue placeholder={field.placeholder} /></SelectTrigger>
          <SelectContent className="interest-options" data-lenis-prevent data-testid={`${id}-options`}>
            {field.options.map(option => <SelectItem key={option} value={option} data-testid={`${id}-option-${slug(option)}`}>{option}</SelectItem>)}
          </SelectContent>
        </Select>;
      case 'multiselect':
        return <div className="chip-set" data-testid={id}>{field.options.map(option => {
          const on = value.includes(option);
          return <button type="button" key={option} className={`option-chip ${on ? 'is-on' : ''}`} aria-pressed={on} onClick={() => onChange(on ? value.filter(v => v !== option) : [...value, option])} data-testid={`${id}-option-${slug(option)}`}>{option}</button>;
        })}</div>;
      case 'radio':
        return <div className="chip-set" data-testid={id}>{field.options.map(option => (
          <button type="button" key={option} className={`option-chip ${value === option ? 'is-on' : ''}`} aria-pressed={value === option} onClick={() => onChange(value === option ? '' : option)} data-testid={`${id}-option-${slug(option)}`}>{option}</button>
        ))}</div>;
      default:
        return <Input id={id} type={field.type} value={value} placeholder={field.placeholder} autoComplete={field.autoComplete} maxLength={254} onChange={e => onChange(e.target.value)} className={`form-input ${error ? 'input-error' : ''}`} aria-invalid={!!error} data-testid={id} />;
    }
  };

  const isButtonGroup = field.type === 'multiselect' || field.type === 'radio';
  return <div className={`discovery-field ${full ? 'span-full' : ''}`}>
    {isButtonGroup
      ? <span className="field-label" data-testid={`${id}-label`}>{label}</span>
      : <label htmlFor={id} data-testid={`${id}-label`}>{label}</label>}
    {control()}
    {error && <p className="field-error" data-testid={`${id}-error`}>{error}</p>}
  </div>;
};
